import { motion } from "framer-motion";

export const CredibilityBar = () => (
  <section data-testid="credibility-bar" className="border-b border-slate-200 bg-white">
    <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-7 sm:flex-row sm:items-center sm:gap-6">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="shrink-0 font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-skybrand"
      >
        Trusted by
      </motion.span>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400"
      >
        Founders and brands in ecommerce, SaaS, local services, and more
      </motion.p>
    </div>
  </section>
);
